import {
  ArrowUpRight,
  Circle,
  CircleDot,
  Hand,
  Lasso,
  Pen,
  Shield,
  Slash,
  Square,
  Type,
  User,
  UserPlus,
} from "lucide-react";
import type { ToolDef } from "../canvas-kit/ui/tool-palette/tool-palette.jsx";

/**
 * Tactics-specific tool ids and palette definition.
 *
 * Kept in tactics (not canvas-kit) because the icon set, labels and grouping
 * are specific to the tactics editor. The whiteboard will define its own
 * `TOOLS` array with different ids — both feed into the same generic
 * `<ToolPalette>` component in `canvas-kit/ui/tool-palette/`.
 */

export type ToolMode =
  | "select"
  | "lasso"
  | "player"
  | "dummy"
  | "opponent"
  | "ball"
  | "pen"
  | "line"
  | "arrow"
  | "rect"
  | "circle"
  | "text";

export const TACTICS_TOOLS: readonly ToolDef<ToolMode>[] = [
  { id: "select", label: "Wählen", Icon: Hand, group: "select" },
  { id: "lasso", label: "Lasso", Icon: Lasso, group: "select" },
  { id: "player", label: "Spieler", Icon: UserPlus, group: "place" },
  { id: "dummy", label: "Dummy", Icon: User, group: "place" },
  { id: "opponent", label: "Gegner", Icon: Shield, group: "place" },
  { id: "ball", label: "Ball", Icon: CircleDot, group: "place" },
  { id: "pen", label: "Stift", Icon: Pen, group: "draw" },
  { id: "line", label: "Linie", Icon: Slash, group: "draw" },
  { id: "arrow", label: "Pfeil", Icon: ArrowUpRight, group: "draw" },
  { id: "rect", label: "Recht.", Icon: Square, group: "draw" },
  { id: "circle", label: "Kreis", Icon: Circle, group: "draw" },
  { id: "text", label: "Text", Icon: Type, group: "draw" },
] as const;

/** Tools that should expose the style card (colour / width / dashed). */
export const TACTICS_PALETTE_STYLE_TOOLS: ReadonlySet<ToolMode> = new Set([
  "pen",
  "line",
  "arrow",
  "rect",
  "circle",
  "text",
]);
